import { Avatar, AvatarProps, forwardRef } from "@chakra-ui/react";

export const AvatarComponent = forwardRef<AvatarProps, typeof Avatar>(
  (props: AvatarProps, ref) => <Avatar ref={ref} {...props} />,
);
